import { render, staticRenderFns } from "./VisitorIngList.vue?vue&type=template&id=21bf317c&scoped=true"
import script from "./VisitorIngList.vue?vue&type=script&lang=js"
export * from "./VisitorIngList.vue?vue&type=script&lang=js"
import style0 from "./VisitorIngList.vue?vue&type=style&index=0&id=21bf317c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bf317c",
  null
  
)

export default component.exports